/* Wild Islay Studio theme: small, dependency-free behaviour. */
(function () {
  'use strict';

  var root = document.documentElement;

  /* Header height, used when the header sits over the homepage hero. */
  function setHeaderHeight() {
    var header = document.querySelector('[data-site-header]');
    if (header) {
      root.style.setProperty('--header-h', header.offsetHeight + 'px');
    }
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);
  window.addEventListener('load', setHeaderHeight);
  document.addEventListener('shopify:section:load', setHeaderHeight);

  /* Full-screen mobile menu. */
  function getMenu() {
    return document.getElementById('mobile-menu');
  }
  function setMenu(open) {
    var menu = getMenu();
    if (!menu) return;
    menu.hidden = !open;
    root.classList.toggle('menu-open', open);
    var openers = document.querySelectorAll('[data-menu-open]');
    for (var i = 0; i < openers.length; i++) {
      openers[i].setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    if (open) {
      var closer = menu.querySelector('[data-menu-close]');
      if (closer) closer.focus();
    } else if (openers.length) {
      openers[0].focus();
    }
  }
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest('[data-menu-open]')) {
      event.preventDefault();
      setMenu(true);
    } else if (target.closest('[data-menu-close]')) {
      event.preventDefault();
      setMenu(false);
    } else if (target.closest('#mobile-menu a')) {
      setMenu(false);
    }
  });
  var menuEl = getMenu();
  if (menuEl) {
    menuEl.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setMenu(false);
    });
  }
  window.addEventListener('resize', function () {
    if (window.innerWidth > 1000 && root.classList.contains('menu-open')) setMenu(false);
  });

  /* Product page: blocks set to show only for certain options, such as thermal labels. */
  function setVariantBlock(block, show) {
    block.hidden = !show;
    var fields = block.querySelectorAll('input, select, textarea');
    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      var state = field.getAttribute('data-variant-off');
      if (!show && !state) {
        field.setAttribute('data-variant-off', field.disabled ? 'was' : 'now');
        field.disabled = true;
      } else if (show && state) {
        field.removeAttribute('data-variant-off');
        if (state === 'now') field.disabled = false;
      }
    }
  }
  function syncVariantBlocks(scope) {
    var blocks = scope.querySelectorAll('[data-variant-only]');
    if (!blocks.length) return;
    var select = scope.querySelector('[data-variant-select]');
    var title = select && select.selectedIndex >= 0 ? select.options[select.selectedIndex].textContent.toLowerCase() : '';
    for (var i = 0; i < blocks.length; i++) {
      var words = blocks[i].getAttribute('data-variant-only').split(',');
      var match = false;
      for (var w = 0; w < words.length; w++) {
        var word = words[w].replace(/^\s+|\s+$/g, '');
        if (word && title.indexOf(word) > -1) match = true;
      }
      setVariantBlock(blocks[i], match);
    }
  }
  function syncAllVariantBlocks() {
    var products = document.querySelectorAll('[data-product]');
    for (var i = 0; i < products.length; i++) syncVariantBlocks(products[i]);
  }
  syncAllVariantBlocks();
  document.addEventListener('DOMContentLoaded', syncAllVariantBlocks);
  document.addEventListener('shopify:section:load', syncAllVariantBlocks);

  /* Product page: variant select updates price, button and image. */
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select || !select.matches) return;

    if (select.matches('[data-variant-select]')) {
      var option = select.options[select.selectedIndex];
      var scope = select.closest('[data-product]') || document;
      var price = scope.querySelector('[data-product-price]');
      var button = scope.querySelector('[data-add-button]');
      var image = scope.querySelector('[data-product-image]');
      if (price && option.getAttribute('data-price-html')) {
        price.innerHTML = option.getAttribute('data-price-html');
      }
      if (button) {
        var available = option.getAttribute('data-available') === 'true';
        button.disabled = !available;
        button.textContent = available ? button.getAttribute('data-label-add') : button.getAttribute('data-label-sold');
      }
      if (image && option.getAttribute('data-image')) {
        image.src = option.getAttribute('data-image');
        image.removeAttribute('srcset');
      }
      syncVariantBlocks(scope);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        window.history.replaceState({}, '', url.toString());
      }
    }

    /* Collection page: sort order. */
    if (select.matches('[data-sort-by]')) {
      var sortUrl = new URL(window.location.href);
      sortUrl.searchParams.set('sort_by', select.value);
      sortUrl.searchParams.delete('page');
      window.location.href = sortUrl.toString();
    }
  });

  /* Product page: check an uploaded file before it is sent with the order.
     Shopify accepts files up to 20MB; the type is checked against what the field allows. */
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('.product-form input[type="file"]')) return;
    var file = input.files && input.files[0];
    var message = '';
    if (file) {
      var isPdf = /\.pdf$/i.test(file.name) || file.type === 'application/pdf';
      var isImage = /^image\//.test(file.type) || /\.(jpe?g|png|webp|gif|heic|heif|tiff?)$/i.test(file.name);
      var accept = input.getAttribute('accept') || '';
      if (file.size > 20 * 1024 * 1024) {
        message = 'This file is larger than 20MB. Please choose a smaller file.';
      } else if (input.hasAttribute('data-pdf-only') && !isPdf) {
        message = 'Please upload a PDF file.';
      } else if (accept === 'image/*' && !isImage) {
        message = 'Please upload a photo or image file.';
      } else if (accept === 'image/*,.pdf' && !isImage && !isPdf) {
        message = 'Please upload an image or a PDF.';
      }
    }
    input.setCustomValidity(message);
    if (message) input.reportValidity();
  });

  /* Product page: related products, fetched from Shopify after the page has loaded. */
  function loadRecommendations() {
    var holders = document.querySelectorAll('[data-product-recs]:not([data-loaded])');
    for (var i = 0; i < holders.length; i++) {
      (function (holder) {
        var url = holder.getAttribute('data-url');
        var grid = holder.querySelector('[data-product-recs-grid]');
        if (!url || !grid || !window.fetch || !window.DOMParser) return;
        holder.setAttribute('data-loaded', '');
        window.fetch(url)
          .then(function (response) { return response.ok ? response.text() : ''; })
          .then(function (markup) {
            if (!markup) return;
            var found = new DOMParser().parseFromString(markup, 'text/html').querySelector('[data-recommendations]');
            if (!found || !found.children.length) return;
            grid.innerHTML = found.innerHTML;
            holder.hidden = false;
          })
          .catch(function () {});
      })(holders[i]);
    }
  }
  loadRecommendations();
  document.addEventListener('shopify:section:load', loadRecommendations);

  /* Product page: thumbnails swap the main image. */
  document.addEventListener('click', function (event) {
    var thumb = event.target && event.target.closest ? event.target.closest('[data-thumb]') : null;
    if (!thumb) return;
    var scope = thumb.closest('[data-product]') || document;
    var image = scope.querySelector('[data-product-image]');
    if (image) {
      image.src = thumb.getAttribute('data-thumb');
      image.removeAttribute('srcset');
      image.alt = thumb.getAttribute('data-alt') || '';
    }
    var thumbs = scope.querySelectorAll('[data-thumb]');
    for (var i = 0; i < thumbs.length; i++) {
      thumbs[i].setAttribute('aria-current', thumbs[i] === thumb ? 'true' : 'false');
    }
  });
})();
